import { useMemo } from 'react'

import { nanoid } from 'nanoid'

export const useNanoID = (length = 6) => useMemo(() => nanoid(length), [length])
